export default "__VITE_ASSET__BwCMs331__"